import React, { useState } from "react";
import "./ContactUs.css";
import axios from "axios";
import { FaMapMarkerAlt, FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import MainNavbar from "../MainNavbar";
import { Helmet } from "react-helmet";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "general",
        message: ""
    });

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage("");
        setErrorMessage("");

        try {
            const res = await axios.post("https://back.varankal.com/api/contact", formData);
            setSuccessMessage(res.data.message);
            setFormData({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                subject: "general",
                message: ""
            });
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "Something went wrong.");
        }
    };


    return (
        <>
            <MainNavbar />
            <div className="contact-container">
                <Helmet>
                    <title>Contact Varankal.com | Tamil Matrimony Support | Get in Touch</title>
                    <meta
                        name="description"
                        content="Need help? Contact Varankal.com – Tamil Nadu’s trusted matrimony service. Email us or call for support, feedback, or partnership inquiries."
                    />
                    <meta
                        name="keywords"
                        content="Contact Tamil Matrimony, Varankal Support, Tamil Matrimony Help, Tamil Marriage Website Contact, Varankal Customer Care, Tamil Nadu Matrimony"
                    />
                </Helmet>
                <div className="contact-left animate-fade">
                    {/* 🚨 Report Section */}
                    <div className="report-box">
                        <p className="report-text">
                            Noticed any suspicious or inappropriate behavior? Help us keep the community safe by reporting it.
                        </p>

                        <button
                            className="report-button"
                            onClick={() => window.location.href = '/submitrequest'}
                        >
                            🚨 Report Someone
                        </button>
                    </div>
                    <hr ></hr>
                    <h3>Contact Information</h3>
                    <div className="contact-details">
                        <p>📞 +91 98765 43210</p>
                        <p>✉️ support@varankal.com</p>
                        <p><FaMapMarkerAlt /> Chennai, Tamil Nadu</p>
                    </div>

                    <div className="social-icons">
                        <li><Link to="https://www.facebook.com/checkpoint/1501092823525282/"><FaFacebookF /></Link></li>
                        <li><Link to="https://x.com/varankal"><FaTwitter /></Link></li>
                        <li><Link to="https://www.instagram.com/varan_kal/"><FaInstagram /></Link></li>
                        <li><Link to="https://www.youtube.com/@Varankal_Matrimony"><FaYoutube /></Link></li>
                    </div>
                </div>

                <div className="contact-right animate-slide">
                    <h1>Get in Touch with Varankal</h1>
                    <p>We’re here to help you every step of the way in your matchmaking journey.</p>

                    {/* Success & Error Messages */}
                    {successMessage && <p className="success-message">{successMessage}</p>}
                    {errorMessage && <p className="error-message">{errorMessage}</p>}

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>First Name</label>
                                <input type="text" name="firstName" placeholder="First Name"
                                    value={formData.firstName} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <label>Last Name</label>
                                <input type="text" name="lastName" placeholder="Last Name"
                                    value={formData.lastName} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" name="email" placeholder="Email"
                                    value={formData.email} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input type="number" name="phone" placeholder="+91 1234567890"
                                    value={formData.phone} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Select Subject</label>
                            <select name="subject" className="subject-select"
                                value={formData.subject} onChange={handleChange} required>
                                <option value="general">General Inquiry</option>
                                <option value="support">Support</option>
                                <option value="feedback">Feedback</option>
                                <option value="others">Others</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Message</label>
                            <textarea name="message" placeholder="Write your message.."
                                value={formData.message} onChange={handleChange} required />
                        </div>
                        <button type="submit" className="send-button">Send Message</button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ContactUs;
